import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const creatorHostStyleId = 'wb-v2-surface-creator-host-theme';

export const creatorHostBridgeStyles = {
  'wb-surface-creator-host': {
    // Identity + body share the primary canvas — no gray rail band.
    '--local-creator-canvas-bg': tokens.color.background.primary,
    '--local-creator-identity-bg': tokens.color.background.primary,
    '--local-creator-identity-border': tokens.color.border.secondary,
    '--local-creator-column-border': tokens.color.border.secondary,
    '--local-creator-column-border-width': tokens.borderWidth.sm,
    '--local-creator-gap': tokens.spacing.xl,
    // Vertical stays compact; horizontal opens up so fields aren't flush to the rail/edge.
    '--local-creator-padding-y': tokens.spacing.xl,
    '--local-creator-padding-x': tokens.spacing.threeXl,
    '--local-creator-identity-width': '320px',

    // Thin, low-contrast scroll chrome (Firefox + WebKit).
    '--local-creator-scrollbar-size': '6px',
    '--local-creator-scrollbar-thumb': tokens.color.border.primary,
    '--local-creator-scrollbar-thumb-hover': tokens.color.border.secondaryAlt,
    '--local-creator-scrollbar-track': 'transparent',
    '--local-creator-scrollbar-radius': tokens.radius.full,

    // Status / error banners.
    '--local-creator-error-bg': tokens.color.background.errorPrimary,
    '--local-creator-error-border': tokens.color.border.error,
    '--local-creator-error-text': tokens.color.text.errorPrimary,
    '--local-creator-error-radius': tokens.radius.md,
    '--local-creator-banner-padding-y': tokens.spacing.md,
    '--local-creator-banner-padding-x': tokens.spacing.lg,

    // Delegated dialog title bar: same values as entity.dialog.host.theme's create header.
    '--local-creator-dialog-header-height': '48px',
    '--local-creator-dialog-header-pad-x': tokens.spacing.md,
    '--local-creator-dialog-header-gap': tokens.spacing.sm,
    '--local-creator-dialog-header-border': tokens.color.border.secondary,
    '--local-creator-dialog-title-size': tokens.font.size.textMdBase,
    '--local-creator-dialog-title-weight': tokens.font.weight.semibold,
    '--local-creator-dialog-title-line': tokens.lineHeight.textMd,
    '--local-creator-dialog-title-color': tokens.color.text.primary,
    '--local-creator-dialog-close-size': '24px',
    '--local-creator-dialog-close-color': tokens.color.text.secondary,
    '--local-creator-dialog-close-hover': tokens.color.text.primary,

    // Step row: done steps carry a success check, the current step the brand fill, upcoming an outline.
    '--local-creator-steps-gap': tokens.spacing.xl,
    '--local-creator-steps-padding-bottom': tokens.spacing.lg,
    '--local-creator-step-gap': tokens.spacing.md,
    '--local-creator-step-connector-width': '120px',
    '--local-creator-step-connector-height': '2px',
    '--local-creator-step-connector-radius': tokens.radius.xxs,
    '--local-creator-step-connector-color': tokens.color.border.secondary,
    '--local-creator-step-connector-done-color': tokens.color.background.brandSolid,
    '--local-creator-step-marker-size': '24px',
    '--local-creator-step-marker-radius': tokens.radius.full,
    '--local-creator-step-marker-font-size': tokens.font.size.textXs,
    '--local-creator-step-marker-weight': tokens.font.weight.semibold,
    '--local-creator-step-marker-bg': tokens.color.background.primary,
    '--local-creator-step-marker-border': tokens.color.border.primary,
    '--local-creator-step-marker-color': tokens.color.text.tertiary,
    '--local-creator-step-done-bg': tokens.color.background.successPrimary,
    '--local-creator-step-done-border': tokens.componentColors.utility.success200,
    '--local-creator-step-done-color': tokens.color.text.successPrimary,
    '--local-creator-step-current-bg': tokens.color.background.brandSolid,
    '--local-creator-step-current-color': tokens.color.text.primaryOnBrand,
    '--local-creator-step-caption-size': tokens.font.size.textXs,
    '--local-creator-step-caption-line': tokens.lineHeight.textXs,
    '--local-creator-step-caption-color': tokens.color.text.tertiary,
    '--local-creator-step-current-caption-color': tokens.color.text.brandSecondary,
    '--local-creator-step-label-size': tokens.font.size.textSm,
    '--local-creator-step-label-line': tokens.lineHeight.textSm,
    '--local-creator-step-label-weight': tokens.font.weight.medium,
    '--local-creator-step-label-color': tokens.color.text.secondary,
    '--local-creator-step-current-label-color': tokens.color.text.primary,
    '--local-creator-step-current-label-weight': tokens.font.weight.semibold,
    '--local-creator-step-skipped-color': tokens.color.text.disabled,
    '--local-creator-step-skipped-border': tokens.color.border.secondary,
    '--local-creator-step-footer-size': tokens.font.size.textSm,
    '--local-creator-step-footer-line': tokens.lineHeight.textSm,
    '--local-creator-step-footer-color': tokens.color.text.tertiary,
  },
  // Identity rail is the heading, not a form row. Match creator section titles
  // (Details / Classification) so Customer and Site read as prime labels.
  'wb-surface-creator-host .creator-identity wb-field': {
    '--local-field-label-color': tokens.color.text.primary,
    '--local-field-label-font-size': tokens.font.size.textMdBase,
    '--local-field-label-font-weight': tokens.font.weight.semibold,
    '--local-field-label-line-height': tokens.lineHeight.textMd,
    '--local-field-gap': tokens.spacing.sm,
  },
};

export function mountCreatorHostTheme(document: Document): void {

  DesignSystem.Mount(document, creatorHostStyleId, creatorHostBridgeStyles);
}
